import React from 'react';
import { services } from '@project/API';
import { saveAs } from 'file-saver';

import '@assets/scss/index.scss';
import './style.scss';

export interface AttachmentLinkProps {
  attachmentId: number;
  fileName: string;
  tableName: string;
  recordId: number | string;
}

export const AttachmentLink: React.FC<AttachmentLinkProps> = React.memo(
  ({ tableName, fileName, attachmentId, recordId }) => {
    const handleFileDownload = async () => {
      if (!tableName) return;

      const resp = await services.attachment.apiAttachmentContentRead(
        '' + recordId,
        '' + attachmentId,
        tableName,
        { responseType: 'blob' },
      );

      // @ts-ignore
      saveAs(resp.data, fileName);
    };

    return (
      <a onClick={handleFileDownload} className={'card-files-item-name'}>
        {fileName}
      </a>
    );
  },
);
